import { FlexBox, Text } from '@dixa/lib-shared-habla';

import { UserProfile } from 'components/userProfile';

import { useConversationRow } from '../../../utils/useConversationRow';

import { ConversationsTableAgentPreferenceTooltip } from './components/tooltip/conversationsTableAgentPreferenceTooltip';
import { getActiveAgentPreference } from './conversationsTableAgentPreference.utils';

/** Represents the content of the reserved for cell in the conversations table. */
export const ConversationsTableAgentPreference = (): JSX.Element => {
  const { conversation } = useConversationRow();

  const agentPreference = getActiveAgentPreference(
    conversation.agent_preference,
  );

  if (!agentPreference) {
    return (
      <Text.Paragraph variant="2" color="tertiary">
        n.a.
      </Text.Paragraph>
    );
  }

  return (
    <FlexBox alignItems="center" gap="250">
      <UserProfile user={agentPreference.agent} truncateName />

      <ConversationsTableAgentPreferenceTooltip
        agentPreference={agentPreference}
      />
    </FlexBox>
  );
};
